import React, { useState, useEffect, useRef } from "react";
import { gl_start, registerSceneHMR, setUniform } from "./webgl0.js";

function Scene() {
this.vertexShader = `#version 300 es
in vec3 aPos;
out vec3 vPos;

void main() {
  gl_Position = vec4(aPos, 1.0);
  vPos = aPos;
}`;

this.fragmentShader = `#version 300 es
precision mediump float;

in vec3 vPos;
out vec4 fragColor;

uniform float uTime;

// HASH FUNCTION TO MAKE PSEUDO RANDOM VALUES
float hash(vec2 p) {
  return fract(sin(dot(p, vec2(12.9898, 78.233))) * 43758.5453);
}

void main() {
  float speed = 2.0;
  float amplitude = 2.0;

  vec3 p = vec3(vPos.xy, sqrt(max(0.0, 1.0 - dot(vPos.xy, vPos.xy))));
  
  vec3 lightSource = normalize(vec3(
    cos(uTime * speed) * amplitude,
    0.0,
    sin(uTime * speed) * amplitude
  ));

  // vec3 lightSource = vec3(1.0, 1.0 ,-1.0);

  fragColor = vec4(0.0, 0.0, 0.0, 1.0);

  if(p.z > 0.0) {
    // COMPUTE DIFFUSE LIGHTING
    float cosineValue = dot(p, lightSource);
    float diffused = max(0.0, cosineValue);

    vec2 center = vec2(0.0, 0.0);
    
    // CREATE GRID
    float gridSize = 50.0; // Higher = more dots
    vec2 gridPos = vPos.xy * gridSize;
    vec2 cellId = floor(gridPos);
    vec2 cellUV = fract(gridPos); // local coordinate
    
    // Generate multiple dots per cell
    for(int i = 0; i < 10; i++) {
      // Random offset within the cell
      float random1 = hash(cellId + vec2(float(i) * 0.1, 0.0));
      float random2 = hash(cellId + vec2(0.0, float(i) * 0.1));
      vec2 dotPos = vec2(random1, random2);
      
      // Distance from current position to dot center
      float dist = length(cellUV - dotPos);
      // float dist = length(center - dotPos);

      // float dotSize = 0.15;
      // float dotSize = length(center - dotPos) * 0.6;
      float dotSize = p.z * 0.5;;
      
      // Threshold based on lighting - brighter areas have more visible dots
      float threshold = 1.0 - diffused;
      
      // if(dist < dotSize && (random2 > threshold || random1 > threshold)) {
      //   fragColor.rgb = vec3(1.0);
      // }

      // Only draw dots near the edge where z approaches 0
      float edgeThickness = 0.5 + sin(uTime) * 0.1; // Adjust this (0.1 = thin edge, 0.5 = thick edge)

      if(dist < dotSize && p.z < edgeThickness && (random2 > threshold || random1 > threshold)) {
        fragColor.rgb = vec3(1.0);
      }

    }
  }
}
`;

  let startTime = Date.now() / 1000;

  this.update = () => {
    setUniform('1f', 'uTime', Date.now() / 1000 - startTime);
  };
}

export default function WebGLCanvas() {
  const canvasRef = useRef(null);
  const [scene, setScene] = useState(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    try { if (typeof canvas.stopRender === 'function') canvas.stopRender(); } catch (e) {}

    const newScene = new Scene();

    gl_start(canvas, newScene);
    setScene(newScene);

    try { registerSceneHMR(module, canvas, () => new Scene()); } catch (e) { /* ignore in non-HMR env */ }
    return () => { try { if (typeof canvas.stopRender === 'function') canvas.stopRender(); } catch (e) {} };
  }, []);

  return (
    <div style = { { display: "flex", justifyContent: "center", gap : "16px" } }>
        <canvas ref={canvasRef} width={400} height={400} style={{ width : "400px", height : "400px", display: "block", margin: "0 auto", background: "black" }} />
        <pre>{ scene?.fragmentShader }</pre>
    </div>
  );
}
